const DEF_META_DATA = {
  title: "Outdoor Clothing, Footwear, Bags and Gear Brand in India - Wildcraft",
  description:
    "Now buy our bestselling &amp; latest Backpacks, Rucksacks, Outdoor/Hiking/Trekking Clothing, Footwear, Bags &amp; Gear from Wildcraft Official Online Store – Free shipping, Fast delivery &amp; Signature warranty",
  keywords: "",
  imageURL: "https://static.omuni.com/wildcraft_logo.png",
  pageURL: "https://wildcraft.com",
  fb_appID: process.env.REACT_APP_FACEBOOK,
  google_site_verification: "",
  content: "Wildcraft",
  facebook_domain_verification: "yxiiwo5knssmf9swklx6o6o53ql8la"
};

export default DEF_META_DATA;
